var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "companies__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('CompanyCard', {
      key: result.id,
      staticClass: "companies__job",
      attrs: {
        "company": result,
        "mini": ""
      }
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab07b2d8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-companies.vue
// module id = null
// module chunks = 